<template>
    <activation-deliverable-content-approval-provider
        v-slot="{
            brief,
            isLoading,
            errors,
            errorMessage,
            onPageClose,
            deliverable,
            task,
            uploadContentUrl,
            requiresCaptionApproval,
            handleFileChange,
            handleResetUploads,
            uploadHeaders,
            uploadedFiles,
            hasUploadedFiles,
            isFileUploading,
            handleRefreshDeliverable,
            goBack
        }"
        style="height: 100%"
    >
        <activation-deliverable-content-approval-view
            :brief="brief"
            :is-loading="isLoading"
            :errors="errors"
            :error-message="errorMessage"
            :deliverable="deliverable"
            :task="task"
            :upload-content-url="uploadContentUrl"
            :requires-caption-approval="requiresCaptionApproval"
            :handle-file-change="handleFileChange"
            :upload-headers="uploadHeaders"
            :uploaded-files="uploadedFiles"
            :has-uploaded-files="hasUploadedFiles"
            :is-file-uploading="isFileUploading"
            @file-change="handleFileChange"
            @reset-uploads="handleResetUploads"
            @close="onPageClose"
            @refresh-deliverable="handleRefreshDeliverable"
            @back="goBack"
        />
    </activation-deliverable-content-approval-provider>
</template>

<script>
    import ActivationDeliverableContentApprovalProvider from '../providers/activation-brief-steps/ActivationDeliverableContentApprovalProvider.vue';
    import ActivationDeliverableContentApprovalView from '../data-views/activation-briefs/partials/deliverables/ActivationDeliverableContentApprovalView.vue';

    export default {
        name: 'ActivationDeliverableContentApprovalViewRouterView',
        components: {
            ActivationDeliverableContentApprovalProvider,
            ActivationDeliverableContentApprovalView
        }
    };
</script>
